import { NotificationService } from 'src/app/shared/services/notification.service';

import { BaseServices } from './../../../kuba.services';
import { ConfirmationService } from 'primeng/api';
import { FoodSafetyServices } from './../../services/foodsafety.services';
import { FoodSafetyNavigationService } from './../../services/foodsafety-navigation.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FoodSafetyList,
  FoodSafetyUserList
} from './../../models/foodsafety-list';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Roles, Rights } from 'src/app/_models';

@Component({
  templateUrl: 'foodsafety-list.component.html',
  standalone: false
})
export class FoodSafetyListComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  private readonly foodSafetyNavigation = inject(FoodSafetyNavigationService);
  foodSafetylist: FoodSafetyList[];
  additionalData: any;
  isAdministrateFs = false;
  deleteDialog = false;
  delete: any;
  deleteButton = false;
  deleteZoneID: number;
  showLoader = false;
  showDialog = false;
  assignedUsers: FoodSafetyUserList[] = [];
  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor
  /**
   * constructor
   */
  constructor(
    public foodSafetyService: FoodSafetyServices,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.FOOD_SAFETY_LIST,
          header: 'Food Safety List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Zone Name', dataKey: 'ZoneName' },
            { title: 'Assigned Access', dataKey: 'UserCount' },
            { title: 'Deviations In Followup', dataKey: 'ShowDeviationreport' }
          ]
        };
      })
    );
  }
  //#endregion

  //#region page-loading

  /**
   * page init event
   */
  ngOnInit(): void {
    let foodSafeties = <FoodSafetyList[]>this.route.snapshot.data['list'];
    if (foodSafeties.length > 0) {
      this.foodSafetylist = foodSafeties;
    }
    this.foodSafetyNavigation.store(
      this.route.snapshot.routeConfig?.path === 'all' ? 'all' : 'own',
      foodSafeties
    );

    this.checkAdministrateFsRights();

    let fs = sessionStorage.getItem('checkParent');
    if (foodSafeties.length === 1) {
      if (fs === 'FS') {
        this.router.navigate(['../../list'], { relativeTo: this.route });
      } else {
        const foodSafety = foodSafeties[0];
        this.autoRedirectToFs(foodSafety);
      }
    }

    sessionStorage.setItem('checkParent', null);
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
  }

  /**
   * Checks if the user has the rights to adminstrate the Food Safeties
   */
  checkAdministrateFsRights() {
    if (+BaseServices.roleId === Roles.EDITOR) {
      this.isAdministrateFs = true;
    } else {
      const fsRightsId = Rights.ADMINISTRATE_FOOD_SAFETY;
      this.isAdministrateFs = BaseServices.checkUserRights(
        fsRightsId,
        BaseServices.UserRole
      );
    }
  }

  /**
   * Navigates the user to the Food Safety if thet have access to it.
   * @param foodSafety FS to navigate to
   */
  autoRedirectToFs(foodSafety: FoodSafetyList) {
    if (this.isAdministrateFs) {
      this.router.navigate(['../../details/' + foodSafety.Id], {
        relativeTo: this.route
      });
    } else {
      const userId = BaseServices.UserId;
      if (foodSafety.FoodSafetyUsers.find(fsu => fsu.UserId === userId)) {
        this.router.navigate(['../../details/' + foodSafety.Id], {
          relativeTo: this.route
        });
      }
    }
  }

  //#endregion

  //#region method
  /**
   * delete food safety
   * @param FoodSafety {{number}}
   */
  deleteFoodSafety(FoodSafety: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.deleteDialog = false;
        this.delete = '';
        this.deleteButton = false;
        this.showLoader = true;
        this.subscriptions.push(
          this.foodSafetyService
            .deleteFoodSafety(FoodSafety)
            .subscribe(result => {
              this.foodSafetyNavigation.invalidate();
              this.subscriptions.push(
                this.foodSafetyService
                  .getAllByBusinessId(BaseServices.BusinessId)
                  .subscribe(res => {
                    this.foodSafetylist = res;
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                    this.showLoader = false;
                  })
              );
            })
        );
      }
    });
  }
  //#endregion

  deleteZoneDialog(zone: any) {
    this.deleteZoneID = zone;
    this.deleteDialog = true;
    this.delete = '';
  }

  onDelete(del: any) {
    this.deleteButton = false;
    if (del == 'DELETE') {
      this.deleteButton = true;
    }
  }

  closeZoneDialog() {
    this.deleteDialog = false;
  }

  /**
   * Opens a popup showing the assigned users in a Food Safety
   * @param users Assigned users in a FS-Zone
   */
  showAssignedUsers(users: FoodSafetyUserList[]) {
    this.showDialog = true;
    this.assignedUsers = [];
    this.assignedUsers = users;
  }

  onHide() {
    this.showDialog = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
